import { createContext } from 'react';

type ThemeContextType = {
  theme: 'light' | 'dark';
};

const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
});

export default ThemeContext;
